/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { calculateServedCustomerSegments } from '../fn/merchants/calculate-served-customer-segments';
import { CalculateServedCustomerSegments$Params } from '../fn/merchants/calculate-served-customer-segments';
import { createMarketingDataToMerchant } from '../fn/merchants/create-marketing-data-to-merchant';
import { CreateMarketingDataToMerchant$Params } from '../fn/merchants/create-marketing-data-to-merchant';
import { createMerchantSites } from '../fn/merchants/create-merchant-sites';
import { CreateMerchantSites$Params } from '../fn/merchants/create-merchant-sites';
import { deleteMarketingDataByMerchant } from '../fn/merchants/delete-marketing-data-by-merchant';
import { DeleteMarketingDataByMerchant$Params } from '../fn/merchants/delete-marketing-data-by-merchant';
import { deleteSite } from '../fn/merchants/delete-site';
import { DeleteSite$Params } from '../fn/merchants/delete-site';
import { getAllMarketingDataByMerchant } from '../fn/merchants/get-all-marketing-data-by-merchant';
import { GetAllMarketingDataByMerchant$Params } from '../fn/merchants/get-all-marketing-data-by-merchant';
import { getMarketingDataByMerchant } from '../fn/merchants/get-marketing-data-by-merchant';
import { GetMarketingDataByMerchant$Params } from '../fn/merchants/get-marketing-data-by-merchant';
import { getMerchantBasicData } from '../fn/merchants/get-merchant-basic-data';
import { GetMerchantBasicData$Params } from '../fn/merchants/get-merchant-basic-data';
import { getMerchantById } from '../fn/merchants/get-merchant-by-id';
import { GetMerchantById$Params } from '../fn/merchants/get-merchant-by-id';
import { getMerchantLogo } from '../fn/merchants/get-merchant-logo';
import { GetMerchantLogo$Params } from '../fn/merchants/get-merchant-logo';
import { getMerchantSite } from '../fn/merchants/get-merchant-site';
import { GetMerchantSite$Params } from '../fn/merchants/get-merchant-site';
import { getMerchantTypeRequestsForAdmin } from '../fn/merchants/get-merchant-type-requests-for-admin';
import { GetMerchantTypeRequestsForAdmin$Params } from '../fn/merchants/get-merchant-type-requests-for-admin';
import { getOperatingLicense } from '../fn/merchants/get-operating-license';
import { GetOperatingLicense$Params } from '../fn/merchants/get-operating-license';
import { getSiteSelectItemsOfMerchant } from '../fn/merchants/get-site-select-items-of-merchant';
import { GetSiteSelectItemsOfMerchant$Params } from '../fn/merchants/get-site-select-items-of-merchant';
import { InputStreamSource } from '../models/input-stream-source';
import { listAllDeliveryMethodsByMerchantIdAndSiteId } from '../fn/merchants/list-all-delivery-methods-by-merchant-id-and-site-id';
import { ListAllDeliveryMethodsByMerchantIdAndSiteId$Params } from '../fn/merchants/list-all-delivery-methods-by-merchant-id-and-site-id';
import { ListMarketingDataViewModel } from '../models/list-marketing-data-view-model';
import { listMerchantContact } from '../fn/merchants/list-merchant-contact';
import { ListMerchantContact$Params } from '../fn/merchants/list-merchant-contact';
import { listMerchants } from '../fn/merchants/list-merchants';
import { ListMerchants$Params } from '../fn/merchants/list-merchants';
import { listMerchantSites } from '../fn/merchants/list-merchant-sites';
import { ListMerchantSites$Params } from '../fn/merchants/list-merchant-sites';
import { listTenders1 } from '../fn/merchants/list-tenders-1';
import { ListTenders1$Params } from '../fn/merchants/list-tenders-1';
import { listTenders2 } from '../fn/merchants/list-tenders-2';
import { ListTenders2$Params } from '../fn/merchants/list-tenders-2';
import { MarketingDataViewModel } from '../models/marketing-data-view-model';
import { MerchantBasicDataViewModel } from '../models/merchant-basic-data-view-model';
import { MerchantContactsViewModel } from '../models/merchant-contacts-view-model';
import { MerchantResponse } from '../models/merchant-response';
import { MerchantSiteViewModel } from '../models/merchant-site-view-model';
import { MerchantViewModel } from '../models/merchant-view-model';
import { PagedModelDeliveryMethodPageResponse } from '../models/paged-model-delivery-method-page-response';
import { PagedModelMerchantResponse } from '../models/paged-model-merchant-response';
import { PagedModelSiteResponseModel } from '../models/paged-model-site-response-model';
import { PagedModelTenderResponseModel } from '../models/paged-model-tender-response-model';
import { PageMerchantSearchResponse } from '../models/page-merchant-search-response';
import { PageSiteMerchantTypesResponse } from '../models/page-site-merchant-types-response';
import { registerMerchant } from '../fn/merchants/register-merchant';
import { RegisterMerchant$Params } from '../fn/merchants/register-merchant';
import { searchMerchant } from '../fn/merchants/search-merchant';
import { SearchMerchant$Params } from '../fn/merchants/search-merchant';
import { ServedCustomerSegmentResponse } from '../models/served-customer-segment-response';
import { SiteResponseModel } from '../models/site-response-model';
import { SiteSelectItemDto } from '../models/site-select-item-dto';
import { updateMarketingDataByMerchant } from '../fn/merchants/update-marketing-data-by-merchant';
import { UpdateMarketingDataByMerchant$Params } from '../fn/merchants/update-marketing-data-by-merchant';
import { updateMerchantBasicData } from '../fn/merchants/update-merchant-basic-data';
import { UpdateMerchantBasicData$Params } from '../fn/merchants/update-merchant-basic-data';
import { updateMerchantContact } from '../fn/merchants/update-merchant-contact';
import { UpdateMerchantContact$Params } from '../fn/merchants/update-merchant-contact';
import { updateMerchantLogo } from '../fn/merchants/update-merchant-logo';
import { UpdateMerchantLogo$Params } from '../fn/merchants/update-merchant-logo';
import { updateRequestedMerchantTypeStatus } from '../fn/merchants/update-requested-merchant-type-status';
import { UpdateRequestedMerchantTypeStatus$Params } from '../fn/merchants/update-requested-merchant-type-status';
import { updateSite } from '../fn/merchants/update-site';
import { UpdateSite$Params } from '../fn/merchants/update-site';
import { uploadOperatingLicense } from '../fn/merchants/upload-operating-license';
import { UploadOperatingLicense$Params } from '../fn/merchants/upload-operating-license';


/**
 * Merchants endpoints.
 */
@Injectable({ providedIn: 'root' })
export class MerchantsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMerchantSite()` */
  static readonly GetMerchantSitePath = '/merchants/{merchantId}/sites/{siteId}';

  /**
   * Gets a site of merchant.
   *
   * Returns the details of the specified site belonging to the merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMerchantSite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantSite$Response(params: GetMerchantSite$Params, context?: HttpContext): Observable<StrictHttpResponse<SiteResponseModel>> {
    const obs = getMerchantSite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a site of merchant.
   *
   * Returns the details of the specified site belonging to the merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMerchantSite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantSite(params: GetMerchantSite$Params, context?: HttpContext): Observable<SiteResponseModel> {
    const resp = this.getMerchantSite$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SiteResponseModel>): SiteResponseModel => r.body)
    );
  }

  /** Path part for operation `updateSite()` */
  static readonly UpdateSitePath = '/merchants/{merchantId}/sites/{siteId}';

  /**
   * Updates a site of merchant.
   *
   * Replaces the data for the specified merchant site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSite$Response(params: UpdateSite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateSite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a site of merchant.
   *
   * Replaces the data for the specified merchant site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSite(params: UpdateSite$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateSite$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSite()` */
  static readonly DeleteSitePath = '/merchants/{merchantId}/sites/{siteId}';

  /**
   * Deletes a site of merchant.
   *
   * Removes the specified site from the merchant. This also removes all sortiment entries and pricing data associated with the site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSite()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSite$Response(params: DeleteSite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteSite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes a site of merchant.
   *
   * Removes the specified site from the merchant. This also removes all sortiment entries and pricing data associated with the site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSite(params: DeleteSite$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteSite$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOperatingLicense()` */
  static readonly GetOperatingLicensePath = '/merchants/{merchantId}/sites/{siteId}/operating-license';

  /**
   * Gets operating license of the given site.
   *
   * Only merchants can see their license, or merchants who have incoming purchases from the owner of the license.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOperatingLicense()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOperatingLicense$Response(params: GetOperatingLicense$Params, context?: HttpContext): Observable<StrictHttpResponse<InputStreamSource>> {
    const obs = getOperatingLicense(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets operating license of the given site.
   *
   * Only merchants can see their license, or merchants who have incoming purchases from the owner of the license.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOperatingLicense$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOperatingLicense(params: GetOperatingLicense$Params, context?: HttpContext): Observable<InputStreamSource> {
    const resp = this.getOperatingLicense$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InputStreamSource>): InputStreamSource => r.body)
    );
  }

  /** Path part for operation `uploadOperatingLicense()` */
  static readonly UploadOperatingLicensePath = '/merchants/{merchantId}/sites/{siteId}/operating-license';

  /**
   * Updates operating license to the given site.
   *
   * Valid file formats to upload: .pdf, .jpeg, .bmp
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadOperatingLicense()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadOperatingLicense$Response(params: UploadOperatingLicense$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadOperatingLicense(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates operating license to the given site.
   *
   * Valid file formats to upload: .pdf, .jpeg, .bmp
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadOperatingLicense$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadOperatingLicense(params: UploadOperatingLicense$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadOperatingLicense$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMarketingDataByMerchant()` */
  static readonly GetMarketingDataByMerchantPath = '/merchants/{merchantId}/marketing-data/{marketingDataId}';

  /**
   * Get marketing data by id.
   *
   * Finds and returns the specified marketing data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMarketingDataByMerchant()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarketingDataByMerchant$Response(params: GetMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingDataViewModel>> {
    const obs = getMarketingDataByMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get marketing data by id.
   *
   * Finds and returns the specified marketing data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMarketingDataByMerchant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarketingDataByMerchant(params: GetMarketingDataByMerchant$Params, context?: HttpContext): Observable<MarketingDataViewModel> {
    const resp = this.getMarketingDataByMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MarketingDataViewModel>): MarketingDataViewModel => r.body)
    );
  }

  /** Path part for operation `updateMarketingDataByMerchant()` */
  static readonly UpdateMarketingDataByMerchantPath = '/merchants/{merchantId}/marketing-data/{marketingDataId}';

  /**
   * Updates marketing data.
   *
   * Update the specified marketing data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMarketingDataByMerchant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMarketingDataByMerchant$Response(params: UpdateMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateMarketingDataByMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates marketing data.
   *
   * Update the specified marketing data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMarketingDataByMerchant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMarketingDataByMerchant(params: UpdateMarketingDataByMerchant$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateMarketingDataByMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteMarketingDataByMerchant()` */
  static readonly DeleteMarketingDataByMerchantPath = '/merchants/{merchantId}/marketing-data/{marketingDataId}';

  /**
   * Delete marketing data.
   *
   * Delete specified marketing data entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMarketingDataByMerchant()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMarketingDataByMerchant$Response(params: DeleteMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteMarketingDataByMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete marketing data.
   *
   * Delete specified marketing data entity
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMarketingDataByMerchant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMarketingDataByMerchant(params: DeleteMarketingDataByMerchant$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteMarketingDataByMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMerchantLogo()` */
  static readonly GetMerchantLogoPath = '/merchants/{merchantId}/logo';

  /**
   * Gets the merchant logo.
   *
   * Returns the logo image URL for the specified merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMerchantLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantLogo$Response(params: GetMerchantLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getMerchantLogo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the merchant logo.
   *
   * Returns the logo image URL for the specified merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMerchantLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantLogo(params: GetMerchantLogo$Params, context?: HttpContext): Observable<string> {
    const resp = this.getMerchantLogo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateMerchantLogo()` */
  static readonly UpdateMerchantLogoPath = '/merchants/{merchantId}/logo';

  /**
   * Updates merchant logo.
   *
   * Replaces the logo image for the specified merchant. Accepted formats: jpg, jpeg, png.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMerchantLogo()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMerchantLogo$Response(params: UpdateMerchantLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateMerchantLogo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates merchant logo.
   *
   * Replaces the logo image for the specified merchant. Accepted formats: jpg, jpeg, png.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMerchantLogo$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMerchantLogo(params: UpdateMerchantLogo$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateMerchantLogo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listMerchantContact()` */
  static readonly ListMerchantContactPath = '/merchants/{merchantId}/contacts';

  /**
   * Gets contacts of merchant.
   *
   * Returns the contact details (persons, phone numbers, emails) for the specified merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMerchantContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchantContact$Response(params: ListMerchantContact$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantContactsViewModel>> {
    const obs = listMerchantContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets contacts of merchant.
   *
   * Returns the contact details (persons, phone numbers, emails) for the specified merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMerchantContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchantContact(params: ListMerchantContact$Params, context?: HttpContext): Observable<MerchantContactsViewModel> {
    const resp = this.listMerchantContact$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MerchantContactsViewModel>): MerchantContactsViewModel => r.body)
    );
  }

  /** Path part for operation `updateMerchantContact()` */
  static readonly UpdateMerchantContactPath = '/merchants/{merchantId}/contacts';

  /**
   * Updates contacts of merchant.
   *
   * Replaces the contact details for the specified merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMerchantContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMerchantContact$Response(params: UpdateMerchantContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateMerchantContact(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates contacts of merchant.
   *
   * Replaces the contact details for the specified merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMerchantContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMerchantContact(params: UpdateMerchantContact$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateMerchantContact$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMerchantBasicData()` */
  static readonly GetMerchantBasicDataPath = '/merchants/{merchantId}/basic-data';

  /**
   * Gets merchant.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMerchantBasicData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantBasicData$Response(params: GetMerchantBasicData$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantBasicDataViewModel>> {
    const obs = getMerchantBasicData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets merchant.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMerchantBasicData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantBasicData(params: GetMerchantBasicData$Params, context?: HttpContext): Observable<MerchantBasicDataViewModel> {
    const resp = this.getMerchantBasicData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MerchantBasicDataViewModel>): MerchantBasicDataViewModel => r.body)
    );
  }

  /** Path part for operation `updateMerchantBasicData()` */
  static readonly UpdateMerchantBasicDataPath = '/merchants/{merchantId}/basic-data';

  /**
   * Updates merchant basic data.
   *
   * Updates the basic data (name, tax number, registration number, etc.) of the specified merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMerchantBasicData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMerchantBasicData$Response(params: UpdateMerchantBasicData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateMerchantBasicData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates merchant basic data.
   *
   * Updates the basic data (name, tax number, registration number, etc.) of the specified merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMerchantBasicData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMerchantBasicData(params: UpdateMerchantBasicData$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateMerchantBasicData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateRequestedMerchantTypeStatus()` */
  static readonly UpdateRequestedMerchantTypeStatusPath = '/merchants/admin/sites/merchant-types/status';

  /**
   * Updates the status of requested merchant types by admin.
   *
   * Updates the status of requested merchant types based on the provided list of request ids and a status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRequestedMerchantTypeStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRequestedMerchantTypeStatus$Response(params: UpdateRequestedMerchantTypeStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateRequestedMerchantTypeStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the status of requested merchant types by admin.
   *
   * Updates the status of requested merchant types based on the provided list of request ids and a status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRequestedMerchantTypeStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRequestedMerchantTypeStatus(params: UpdateRequestedMerchantTypeStatus$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateRequestedMerchantTypeStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listMerchants()` */
  static readonly ListMerchantsPath = '/merchants';

  /**
   * Lists merchants.
   *
   * Returns a paged list of all registered merchants. Requires EASYLOT_ADMIN or IMPERSONATION role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMerchants()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchants$Response(params?: ListMerchants$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelMerchantResponse>> {
    const obs = listMerchants(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists merchants.
   *
   * Returns a paged list of all registered merchants. Requires EASYLOT_ADMIN or IMPERSONATION role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMerchants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchants(params?: ListMerchants$Params, context?: HttpContext): Observable<PagedModelMerchantResponse> {
    const resp = this.listMerchants$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelMerchantResponse>): PagedModelMerchantResponse => r.body)
    );
  }

  /** Path part for operation `registerMerchant()` */
  static readonly RegisterMerchantPath = '/merchants';

  /**
   * Starts registration of a new merchant.
   *
   * Creates a new merchant and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerMerchant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerMerchant$Response(params: RegisterMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantViewModel>> {
    const obs = registerMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Starts registration of a new merchant.
   *
   * Creates a new merchant and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerMerchant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerMerchant(params: RegisterMerchant$Params, context?: HttpContext): Observable<MerchantViewModel> {
    const resp = this.registerMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MerchantViewModel>): MerchantViewModel => r.body)
    );
  }

  /** Path part for operation `listMerchantSites()` */
  static readonly ListMerchantSitesPath = '/merchants/{merchantId}/sites';

  /**
   * List sites of merchant (HAL).
   *
   * Returns a paged HAL representation of all operational sites belonging to the specified merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMerchantSites()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchantSites$Response(params: ListMerchantSites$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelSiteResponseModel>> {
    const obs = listMerchantSites(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List sites of merchant (HAL).
   *
   * Returns a paged HAL representation of all operational sites belonging to the specified merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMerchantSites$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMerchantSites(params: ListMerchantSites$Params, context?: HttpContext): Observable<PagedModelSiteResponseModel> {
    const resp = this.listMerchantSites$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelSiteResponseModel>): PagedModelSiteResponseModel => r.body)
    );
  }

  /** Path part for operation `createMerchantSites()` */
  static readonly CreateMerchantSitesPath = '/merchants/{merchantId}/sites';

  /**
   * Creates a new site for a merchant.
   *
   * Creates a new operational site for the specified merchant and returns the saved resource.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMerchantSites()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMerchantSites$Response(params: CreateMerchantSites$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantSiteViewModel>> {
    const obs = createMerchantSites(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new site for a merchant.
   *
   * Creates a new operational site for the specified merchant and returns the saved resource.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMerchantSites$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMerchantSites(params: CreateMerchantSites$Params, context?: HttpContext): Observable<MerchantSiteViewModel> {
    const resp = this.createMerchantSites$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MerchantSiteViewModel>): MerchantSiteViewModel => r.body)
    );
  }

  /** Path part for operation `getAllMarketingDataByMerchant()` */
  static readonly GetAllMarketingDataByMerchantPath = '/merchants/{merchantId}/marketing-data';

  /**
   * Gets marketing data.
   *
   * Finds and returns the all marketing data by the specifed merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMarketingDataByMerchant()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMarketingDataByMerchant$Response(params: GetAllMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<ListMarketingDataViewModel>> {
    const obs = getAllMarketingDataByMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets marketing data.
   *
   * Finds and returns the all marketing data by the specifed merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMarketingDataByMerchant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMarketingDataByMerchant(params: GetAllMarketingDataByMerchant$Params, context?: HttpContext): Observable<ListMarketingDataViewModel> {
    const resp = this.getAllMarketingDataByMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ListMarketingDataViewModel>): ListMarketingDataViewModel => r.body)
    );
  }

  /** Path part for operation `createMarketingDataToMerchant()` */
  static readonly CreateMarketingDataToMerchantPath = '/merchants/{merchantId}/marketing-data';

  /**
   * Creates marketing data.
   *
   * Create marketing data to the specified merchant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMarketingDataToMerchant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMarketingDataToMerchant$Response(params: CreateMarketingDataToMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingDataViewModel>> {
    const obs = createMarketingDataToMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates marketing data.
   *
   * Create marketing data to the specified merchant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMarketingDataToMerchant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMarketingDataToMerchant(params: CreateMarketingDataToMerchant$Params, context?: HttpContext): Observable<MarketingDataViewModel> {
    const resp = this.createMarketingDataToMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MarketingDataViewModel>): MarketingDataViewModel => r.body)
    );
  }

  /** Path part for operation `calculateServedCustomerSegments()` */
  static readonly CalculateServedCustomerSegmentsPath = '/merchants/sites/calculate-servable-customer-segments';

  /**
   * Returns servable customer segments.
   *
   * Calculates servable customer segments with status set based on selected merchant types.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculateServedCustomerSegments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculateServedCustomerSegments$Response(params: CalculateServedCustomerSegments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServedCustomerSegmentResponse>>> {
    const obs = calculateServedCustomerSegments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Returns servable customer segments.
   *
   * Calculates servable customer segments with status set based on selected merchant types.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculateServedCustomerSegments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculateServedCustomerSegments(params: CalculateServedCustomerSegments$Params, context?: HttpContext): Observable<Array<ServedCustomerSegmentResponse>> {
    const resp = this.calculateServedCustomerSegments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ServedCustomerSegmentResponse>>): Array<ServedCustomerSegmentResponse> => r.body)
    );
  }

  /** Path part for operation `searchMerchant()` */
  static readonly SearchMerchantPath = '/merchants/search-by-segments';

  /**
   * Search merchants by filter and customer segments.
   *
   * Search merchants by the specified MerchantSearchDetailsFilter object and customer segments
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchMerchant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchMerchant$Response(params: SearchMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<PageMerchantSearchResponse>> {
    const obs = searchMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search merchants by filter and customer segments.
   *
   * Search merchants by the specified MerchantSearchDetailsFilter object and customer segments
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchMerchant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchMerchant(params: SearchMerchant$Params, context?: HttpContext): Observable<PageMerchantSearchResponse> {
    const resp = this.searchMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageMerchantSearchResponse>): PageMerchantSearchResponse => r.body)
    );
  }

  /** Path part for operation `getMerchantById()` */
  static readonly GetMerchantByIdPath = '/merchants/{merchantId}';

  /**
   * Gets a merchant by id.
   *
   * Returns the merchant with the specified merchantId. Requires EASYLOT_ADMIN role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMerchantById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantById$Response(params: GetMerchantById$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantResponse>> {
    const obs = getMerchantById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a merchant by id.
   *
   * Returns the merchant with the specified merchantId. Requires EASYLOT_ADMIN role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMerchantById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantById(params: GetMerchantById$Params, context?: HttpContext): Observable<MerchantResponse> {
    const resp = this.getMerchantById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MerchantResponse>): MerchantResponse => r.body)
    );
  }

  /** Path part for operation `listTenders1()` */
  static readonly ListTenders1Path = '/merchants/{merchantId}/tenders';

  /**
   * Listing tenders of a merchant.
   *
   * Lists available tenders of specified merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTenders1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenders1$Response(params: ListTenders1$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelTenderResponseModel>> {
    const obs = listTenders1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing tenders of a merchant.
   *
   * Lists available tenders of specified merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTenders1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenders1(params: ListTenders1$Params, context?: HttpContext): Observable<PagedModelTenderResponseModel> {
    const resp = this.listTenders1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelTenderResponseModel>): PagedModelTenderResponseModel => r.body)
    );
  }

  /** Path part for operation `listTenders2()` */
  static readonly ListTenders2Path = '/merchants/{merchantId}/sites/{siteId}/tenders';

  /**
   * Listing tenders of a merchant for a site.
   *
   * Lists available tenders of specified merchant for the specified site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTenders2()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenders2$Response(params: ListTenders2$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelTenderResponseModel>> {
    const obs = listTenders2(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing tenders of a merchant for a site.
   *
   * Lists available tenders of specified merchant for the specified site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTenders2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenders2(params: ListTenders2$Params, context?: HttpContext): Observable<PagedModelTenderResponseModel> {
    const resp = this.listTenders2$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelTenderResponseModel>): PagedModelTenderResponseModel => r.body)
    );
  }

  /** Path part for operation `listAllDeliveryMethodsByMerchantIdAndSiteId()` */
  static readonly ListAllDeliveryMethodsByMerchantIdAndSiteIdPath = '/merchants/{merchantId}/sites/{siteId}/delivery/methods';

  /**
   * Lists delivery methods for a site.
   *
   * Returns all configured delivery methods for the specified merchant site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllDeliveryMethodsByMerchantIdAndSiteId()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllDeliveryMethodsByMerchantIdAndSiteId$Response(params: ListAllDeliveryMethodsByMerchantIdAndSiteId$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelDeliveryMethodPageResponse>> {
    const obs = listAllDeliveryMethodsByMerchantIdAndSiteId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lists delivery methods for a site.
   *
   * Returns all configured delivery methods for the specified merchant site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllDeliveryMethodsByMerchantIdAndSiteId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllDeliveryMethodsByMerchantIdAndSiteId(params: ListAllDeliveryMethodsByMerchantIdAndSiteId$Params, context?: HttpContext): Observable<PagedModelDeliveryMethodPageResponse> {
    const resp = this.listAllDeliveryMethodsByMerchantIdAndSiteId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelDeliveryMethodPageResponse>): PagedModelDeliveryMethodPageResponse => r.body)
    );
  }

  /** Path part for operation `getSiteSelectItemsOfMerchant()` */
  static readonly GetSiteSelectItemsOfMerchantPath = '/merchants/current/sites/select-items';

  /**
   * Gets site select items.
   *
   * Finds and returns site select items of logged in merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSiteSelectItemsOfMerchant()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteSelectItemsOfMerchant$Response(params?: GetSiteSelectItemsOfMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SiteSelectItemDto>>> {
    const obs = getSiteSelectItemsOfMerchant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets site select items.
   *
   * Finds and returns site select items of logged in merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSiteSelectItemsOfMerchant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteSelectItemsOfMerchant(params?: GetSiteSelectItemsOfMerchant$Params, context?: HttpContext): Observable<Array<SiteSelectItemDto>> {
    const resp = this.getSiteSelectItemsOfMerchant$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SiteSelectItemDto>>): Array<SiteSelectItemDto> => r.body)
    );
  }

  /** Path part for operation `getMerchantTypeRequestsForAdmin()` */
  static readonly GetMerchantTypeRequestsForAdminPath = '/merchants/admin/sites/merchant-types';

  /**
   * Gets merchant type requests.
   *
   * Finds and returns merchant type requests.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMerchantTypeRequestsForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantTypeRequestsForAdmin$Response(params?: GetMerchantTypeRequestsForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSiteMerchantTypesResponse>> {
    const obs = getMerchantTypeRequestsForAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets merchant type requests.
   *
   * Finds and returns merchant type requests.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMerchantTypeRequestsForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMerchantTypeRequestsForAdmin(params?: GetMerchantTypeRequestsForAdmin$Params, context?: HttpContext): Observable<PageSiteMerchantTypesResponse> {
    const resp = this.getMerchantTypeRequestsForAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageSiteMerchantTypesResponse>): PageSiteMerchantTypesResponse => r.body)
    );
  }

}
